import { render, staticRenderFns } from "./BusinessDocumentListView.vue?vue&type=template&id=2756d53c&"
import script from "./BusinessDocumentListView.vue?vue&type=script&lang=js&"
export * from "./BusinessDocumentListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports